import { render, staticRenderFns } from "./MakeInspection.vue?vue&type=template&id=28085a74&scoped=true&lang=pug&"
import script from "./MakeInspection.vue?vue&type=script&lang=js&"
export * from "./MakeInspection.vue?vue&type=script&lang=js&"
import style0 from "./MakeInspection.vue?vue&type=style&index=0&id=28085a74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28085a74",
  null
  
)

export default component.exports